import DefaultNavbar from './Navbar';
import NavbarFullHeightLink from './FullHeightLink';
import NavbarFullHeightDropDown from './FullHeightDropDown';

export const FullHeightLink = NavbarFullHeightLink;
export const FullHeightDropDown = NavbarFullHeightDropDown;
export const Navbar = DefaultNavbar;

export default { Navbar, FullHeightDropDown, FullHeightLink };
